module.exports = __webpack_public_path__ + "static/media/Advent02.81dc4c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Advent02.jpg
// module id = 371
// module chunks = 0